import React, { useEffect } from 'react';
import { Outlet } from "react-router-dom";
import AppBar from "./Appbar";

function index(props) {



    return (
        <div>
            <AppBar mediadQuery={props.mediadQuery}  style={{     height:'120vh',}}/>
            <Outlet props={props.title}  style={{   height:'120vh',}}/>
        </div>
    );
}

export default index;